import { defineMessage } from 'services/localization';

export const messages = {
    mandatoryFieldsErrorText: defineMessage('please_fill_in_the_mandatory_fields'),
    understatedAmountErrorText: defineMessage('amount_cannot_be_less_than'),
    exceededAmountErrorText: defineMessage('amount_cannot_be_more_than'),
    mandatoryNameErrorText: defineMessage('name_is_mandatory'),
    mandatoryDescriptionErrorText: defineMessage('description_is_mandatory'),
    exceededNameLengthErrorText: defineMessage('max_length_of_name_is'),
};
